/**
 * Utilitaires JWT partagés.
 * Centralise le décodage et la vérification d'expiration des tokens JWT
 * pour éviter la duplication entre authService.ts et apiClient.ts.
 */

/** Retourne true si le token est expiré (avec buffer de 5 min) */
export function isTokenExpired(token: string): boolean {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    const exp = payload.exp;
    if (!exp) return true;
    return Date.now() >= exp * 1000 - 5 * 60 * 1000;
  } catch {
    return true;
  }
}

/** Retourne la date d'expiration du token, ou null si invalide */
export function getTokenExpiration(token: string): Date | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp ? new Date(payload.exp * 1000) : null;
  } catch {
    return null;
  }
}

/** Retourne le timestamp d'expiration en ms, ou null si invalide */
export function getTokenExpirationMs(token: string): number | null {
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp ? payload.exp * 1000 : null;
  } catch {
    return null;
  }
}
